import { AppRouteProps } from "@bsm/component";
import { StudentSesignationCollectionIndividualContainer } from "./container/StudentSesignationCollectionIndividualContainer";

export const StudentSesignationCollectionIndividualRoutes: Array<AppRouteProps> = [
    {
        path: "designationCollectionIndividual",
        element: <StudentSesignationCollectionIndividualContainer />,
    },
];